
<div class="grid grid-rows-2 grid-cols-1 shadow">
  <button
    class="h-11 w-11 p-0 rounded-b-none hover:outline outline-2 outline-offset-1 text-white rounded flex flex-cols justify-center items-center dark:text-gray-800 active:scale-[0.98] touch-manipulation"
    :class="zoomInClass"
    @click="zoomIn"
  >
    <fa-icon
      icon="fa-solid fa-plus"
      size="xl"
      fixed-width
    />
  </button>
  <button
    class="h-11 w-11 p-0 rounded-t-none outline-2 outline-offset-1 text-white rounded flex flex-cols justify-center items-center dark:text-gray-800 active:scale-[0.98] touch-manipulation"
    :class="zoomOutClass"
    @click="zoomOut"
  >
    <fa-icon
      icon="fa-solid fa-minus"
      size="xl"
      fixed-width
    />
  </button>
</div>
